import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
// eslint-disable-next-line import/no-named-as-default
import Landing from '../Landing';
import LandingV2 from './Landing';
import useDarkly from '../../hooks/useDarkly';
import { isNewLandingEligible } from '../../dataLoaders/landingRootLoader';

const RootLanding = () => {
  const showLandingV2 = useDarkly('landing-page-v2');
  const location = useLocation();
  const params = useParams();

  const isEligible = isNewLandingEligible(params);

  if (showLandingV2 && isEligible) {
    // IMPORTANT: key is needed to force remount of component
    // TODO: Ensure this stays in place even after the other landing page is removed
    return <LandingV2 key={location.pathname} />;
  }

  return <Landing />;
};

export default RootLanding;
